<template>
  <!-- 地图定位 -->
  <a-modal
      v-model:visible="visibleMap"
      :bodyStyle="{ padding: '0' }"
      :footer="null"
      :mask="false"
      :width="800"
      title="地图定位"
      @cancel="handleCancel"
  >
    <div style="width: 800px; height: 700px">
      <iframe
          v-if="src"
          :allowfullscreen="true"
          :src="src"
          frameborder="0"
          height="100%"
          width="100%"
      >
      </iframe>
    </div>
  </a-modal>
</template>

<script>
import {onMounted, reactive, toRefs} from "vue";
import {mapKey} from "../../../../config.js";

export default {
  props: {
    showMap: {
      type: Boolean,
      default: false,
    },
    latitude: {
      default: "",
    },
    longitude: {
      default: "",
    },
  },
  setup(props, content) {
    window.addEventListener(
        "message",
        function (event) {
          // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
          var loc = event.data;
          if (loc && loc.module == "locationPicker") {
            //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
            mapselect.latitude = loc.latlng.lat;
            mapselect.longitude = loc.latlng.lng;
            content.emit("selectValue", {
              latitude: mapselect.latitude,
              longitude: mapselect.longitude,
            });
            if (loc.poiaddress.indexOf("市")) {
              let address =
                  loc.poiaddress.slice(loc.poiaddress.indexOf("市") + 1) +
                  loc.poiname;
              content.emit("address", address);
            } else {
              let address = loc.poiaddress + loc.poiname;
              content.emit("address", address);
            }
            content.emit("close");
          }
        },
        false
    );
    // 地图
    const mapselect = reactive({
      visibleMap: props.showMap,
      latitude: props.latitude,
      longitude: props.longitude,
      src: "",
      // 打开地图
      handleOpenMap() {
        if (mapselect.latitude && mapselect.longitude) {
          mapselect.src =
              "https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=" +
              mapKey +
              "&referer=PMS";
          mapselect.src =
              mapselect.src +
              "&coord=" +
              mapselect.latitude +
              "," +
              mapselect.longitude;
        } else {
          mapselect.src =
              "https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=" +
              mapKey +
              "&referer=PMS";
        }
      },
      handleCancel() {
        content.emit("close");
      },
    });

    onMounted(() => {
      mapselect.handleOpenMap();
    });

    return {
      ...toRefs(mapselect),
    };
  },
};
</script>

<style></style>
